<template>
  <div>
    <h1>Terms of Service</h1>
    <p>
      Legal: 
      <router-link to="privacypolicy">Privacy Policy</router-link>
      |
      <router-link to="cookiepolicy">Cookie Policy</router-link>
      |
      <router-link to="termsofservice">Terms of Service</router-link>
    </p>

    <div v-if="article" v-html="article.content" class="markdown mx-0 mt-4 dynamic-content"> </div>

  </div>
</template>

<script>

import articleService from "@/services/articleService";

export default {
  name: "PrivacyPolicy",
  components: {
  },
  props: {
  },
  data: function() {
    return {
      article: null,
    };
  },
  created() {
  },
  async mounted() {
    this.article = await articleService.get('termsofservice');
  },
  methods: {
  },
  watch: {
  }
};
</script>

<style scoped>
</style>